import React, { useCallback, useEffect, useState } from "react";
import styles from './index.module.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlus, faShuffle, faXmark } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { getAllActiveLotteries } from "../../../redux/features/lottery/lotteryServices";
import SkeletonTicketCard from "../../Skeleton/TicketCardSekeleton";
import { useNavigate } from "react-router-dom";
import { getAllShuffleTickets } from "../../../redux/features/ticket/ticketServices";
import { insertItemToCart, insertTicketBulkToCart } from "../../../redux/features/cart/cartServices";
import BeatLoader from "react-spinners/BeatLoader";
import Capricom from '../../../assets/images/astro/1.png';
import Aquarius from '../../../assets/images/astro/2.png';
import Pisces from '../../../assets/images/astro/3.png';
import Aries from '../../../assets/images/astro/4.png';
import Taurus from '../../../assets/images/astro/5.png';
import Gemini from '../../../assets/images/astro/6.png';
import Cancer from '../../../assets/images/astro/7.png';
import Leo from '../../../assets/images/astro/8.png';
import Virgo from '../../../assets/images/astro/9.png';
import Libra from '../../../assets/images/astro/10.png';
import Scorpio from '../../../assets/images/astro/11.png';
import Sagittarius from '../../../assets/images/astro/12.png';
import { useTranslation } from "react-i18next";
import { setShouldRefreshCount } from "../../../redux/features/cart/cartSlice";
import PayhereSubscriptionForm from "../../PayhereSubscriptionForm/PayhereSubscriptionForm";
import SoldOut from "../../SoldOut";
import { showToast } from "../../ToastMsg";
import CompleteImg from '../../../assets/images/completed_stamp.png';
import { createNewSubscription } from "../../../redux/features/subscription/subscriptionServices";

const astroImages = {
  1: Capricom,
  2: Aquarius,
  3: Pisces,
  4: Aries,
  5: Taurus,
  6: Gemini,
  7: Cancer,
  8: Leo,
  9: Virgo,
  10: Libra,
  11: Scorpio,
  12: Sagittarius,
};

const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const getDayTime = () => {
  const timeNow = new Date().toLocaleTimeString('en-US', {
    timeZone: 'Asia/Colombo', // Force Sri Lankan time
    hour12: false
  });
  return timeNow;
}

const TicketListing = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const { isLotteriesLoading, lotteries } = useSelector((state) => state.lottery.allActiveLotteries);
  const { isUserDetailsLoading, isLoggedIn, details } = useSelector((state) => state.auth.userDetails);
  const { isTicketsLoading, shuffledTickets } = useSelector((state) => state.ticket.allShuffleTickets);
  const subscription = useSelector((state) => state.subscription.subscriptionDetails.subscriptionResponse);

  const [isTicketListModalOpen, setTicketListModalOpen] = useState(false);
  const [isTicketBulkModalOpen, setTicketBulkModalOpen] = useState(false);
  const [isSubscribeModalOpen, setSubscribeModalOpen] = useState(false);
  const [brand, setBrand] = useState('');
  const [addedToCartIds, setAddedToCartIds] = useState([]);
  const [loadingTicketId, setLoadingTicketId] = useState(null);
  const [isMorning, setMorning] = useState(true);
  const [bulkTicketBrand, setBulkTicketBrand] = useState(null);
  const [bulkCount, setBulkCount] = useState(0);
  const [creatingBulk, setCreatingBulk] = useState(false);
  const [subscribeBrand, setSubscribeBrand] = useState(null);

  const [pageIndex, setPageIndex] = useState(0);
  const ticketsPerPage = 8;

  const today = new Date();
  const formattedDate = formatDate(today);

  const fetchActiveTickets = useCallback(
    (filters = {}) => {
      const params = {
        draw_date: formattedDate,
        ...filters,
      };
      dispatch(getAllActiveLotteries(params));
    },
    [dispatch, formattedDate]
  );

  useEffect(() => {
    fetchActiveTickets();
  }, [fetchActiveTickets]);

  // useEffect(() => {
  //   const timeToday = getDayTime();
  //   const [hour, minute] = timeToday.split(':').map(Number);
  //   if (hour > 11 || (hour === 11 && minute > 59)) {
  //     setMorning(false);
  //   } else {
  //     setMorning(true);
  //   }
  // }, []);

  const selectBrand = async (ticket) => {
    if (!isUserDetailsLoading)
      if (isLoggedIn) {
        try {
          const timeToday = getDayTime();
          // const [hour, minute] = timeToday.split(':').map(Number);
          // if (hour > 11 || (hour === 11 && minute > 59)) {
          //   setBulkTicketBrand(ticket)
          //   setTicketBulkModalOpen(true);
          //   setTicketListModalOpen(false);
          // } else {
          document.body.style.overflow = 'hidden';
          window.scrollTo({ top: 0, behavior: 'smooth' });
          const params = {
            draw_date: formattedDate,
            lottery_brand_day_code: ticket.lottery_brand_day.code
          };
          dispatch(getAllShuffleTickets(params));
          setTicketListModalOpen(true);
          setTicketBulkModalOpen(false);
          setBrand(ticket);
          document.body.classList.add("noScroll");
          // }
        } catch (error) {
          showToast('error', error.message);
        }
      } else {
        if (details?.id) {
          navigate('/auth/login-verify')
        } else {
          navigate('/auth/login')
        }
      }
  }

  const visibleTickets = Array.isArray(shuffledTickets)
    ? shuffledTickets.slice(
      pageIndex * ticketsPerPage,
      (pageIndex + 1) * ticketsPerPage
    )
    : [];

  const handleShuffle = () => {
    const nextPage = (pageIndex + 1) % Math.ceil(shuffledTickets?.length / ticketsPerPage);
    setPageIndex(nextPage);
  };

  //Insert into the cart
  const addToCart = async (ticket) => {
    try {
      setLoadingTicketId(ticket.id);
      const data = {
        ticket_id: ticket.id
      }
      const response = await dispatch(insertItemToCart(data)).unwrap();
      if (response.success) {
        dispatch(setShouldRefreshCount(true));
        setAddedToCartIds((prev) => [...prev, ticket.id]);
      }
    } catch (error) {
      showToast('error', error.message);
    } finally {
      setLoadingTicketId(null); // reset loading ID
    }
  }

  const addBulkToCart = async () => {
    const bulkData = {
      lottery_brand_id: bulkTicketBrand.lottery_brand_day.lottery_brand.id,
      quantity: bulkCount,
      draw_date: bulkTicketBrand.draw_date
    }
    try {
      if (bulkCount > 0) {
        setCreatingBulk(true);
        const response = await dispatch(insertTicketBulkToCart(bulkData)).unwrap();
        if (response.success === true) {
          dispatch(setShouldRefreshCount(true));
          setCreatingBulk(false);
          setBulkCount(0);
          setTicketBulkModalOpen(false);
        }
      }
    } catch (error) {
      showToast('error', error.message);
      setCreatingBulk(false);
    }
  }

  //Subscribe
  const selectSubscribeBrand = async (ticket) => {
    if (!isUserDetailsLoading)
      if (isLoggedIn) {
        setSubscribeModalOpen(true);
        setSubscribeBrand(ticket);
        document.body.style.overflow = 'hidden';
      } else {
        if (details?.id) {
          navigate('/auth/login-verify')
        } else {
          navigate('/auth/login')
        }
      }
  }

  const [subCount, setSubCount] = useState(0);

  const [subData, setSubData] = useState({
    recurrence: '',
    duration: '',
    amount: '',
  });

  const [subError, setSubError] = useState({
    recurrence: '',
    duration: '',
    amount: '',
    count: ''
  });

  const [activeFirstBtn, setActiveFirstBtn] = useState(false);
  const [activeSecondtBtn, setActiveSecondBtn] = useState(false);
  const [activeThirdBtn, setActiveThirdBtn] = useState(false);
  const [activeFourthBtn, setActiveFourthBtn] = useState(false);
  const [activeDuFirstBtn, setActiveDuFirstBtn] = useState(false);
  const [activeDuSecondtBtn, setActiveDuSecondBtn] = useState(false);
  const [activeDuThirdBtn, setActiveDuThirdBtn] = useState(false);
  const [activeDuFourthBtn, setActiveDuFourthBtn] = useState(false);

  const [isForever, setForever] = useState(false);
  const [isLoading, setLoading] = useState(false);

  const validateSubscription = () => {
    const errors = {};
    if (!subData.recurrence) {
      errors.recurrence = "Please select a subscription type.";
    }
    if (!isForever && !subData.duration) {
      errors.duration = "Please select a duration.";
    }
    if (subCount < 1) {
      errors.count = "At least 1 ticket is required.";
    }

    setSubError(errors);
    return Object.keys(errors).length === 0;
  };

  const checkoutOrder = async () => {
    if (!validateSubscription()) {
      return; // Stop if validation fails
    }
    setLoading(true);
    const data = {
      lottery_brand_id: subscribeBrand?.lottery_brand_day.lottery_brand.id,
      subscription_type: subData?.recurrence,
      duration_type: isForever === true ? 'Forever' : subData.duration,
      quantity: subCount,
      amount: parseFloat(subCount * subscribeBrand?.price)
    };
    try {
      const response = await dispatch(createNewSubscription(data)).unwrap();
      if (response.success === true) {
        navigate(`/subscription/${response.subscription.id}`)
        setLoading(false);
      } else {
        showToast("error", response.message);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      showToast('error', error)
    }
  };

  return (
    <>
      {isLotteriesLoading ? (
        <div className={styles.homeContainer}>
          <div className={`main-container`}>
            <div className={`container-content`}>
              <div className={styles.homeHeader}>
                {/* <h1 className={styles.listingTitle}>FEATURED TODAY</h1> */}
              </div>
              <div className={styles.ticketList}>
                {Array.from({ length: 8 }).map((_, index) => (
                  <SkeletonTicketCard key={index} />
                ))}
              </div>
            </div>
          </div>
        </div>
      ) : (
        lotteries.length > 0 &&
        <div className={styles.homeContainer}>
          <div className={`main-container`}>
            <div className={`container-content`}>
              <div className={styles.homeHeader}>
                {/* <h1 className={styles.listingTitle}>FEATURED TODAY</h1> */}
              </div>
              <div className={styles.ticketList}>
                {lotteries?.map((ticket, index) => (
                  <div className={styles.lotteryBoxCard} key={index}>
                    <img src={ticket.lottery_brand_day.sample_url} alt="Sample" className={styles.ticketImg} />
                    <div className={`${styles.detailscard} ${styles[ticket.lottery_brand_day.lottery_brand.code.toLowerCase() || 'default']}`}>
                      <div className={styles.ticketDetails}>
                        <p className={styles.pricetitle}>{t(`Next super Prize`)}</p>
                        <p className={styles.prize}>{t(`Rs`)} {ticket.mega_prize.toLocaleString()}</p>
                        <p className={styles.brandName}>{t(ticket.lottery_brand_day.lottery_brand.name)}</p>
                        <div className={styles.detailsRow}>
                          <p className={styles.rowText}>{t(`Draw`)}: {ticket.draw_no}</p>
                          <p className={styles.rowText}>{t(`Date`)}: {ticket.draw_date}</p>
                        </div>
                        {ticket.is_completed === false ?
                          <div className={styles.buttonsCol}>
                            <button className={styles.buyBtn} type="button"
                              onClick={() => {
                                selectBrand(ticket);
                              }}
                            >{t(`Buy`)}</button>
                            <button className={styles.subscribeBtn} type="button" onClick={() => { selectSubscribeBrand(ticket) }}>Subscribe</button>
                          </div>
                          : <div style={{ textAlign: 'center', marginTop: '20px' }}>
                            <img src={CompleteImg} alt="Completed" width={180} />
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
      {isTicketListModalOpen &&
        <>
          <div className={`main-container`}>
            <div className={styles.ticketModal}>
              <div className={styles.closeRow}>
                <FontAwesomeIcon icon={faXmark} className={styles.xClass} size="2xl" onClick={() => {
                  setTicketListModalOpen(false);
                  document.body.style.overflow = 'unset';
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                  setPageIndex(0);
                }} />
              </div>
              <div className={styles.ticketModalContainer}>
                <div className={styles.shuffleHeader}>
                  <h2 className={styles.listingTitle}>{t(brand.lottery_brand_day.lottery_brand.name)}</h2>
                  {visibleTickets?.length > 0 && pageIndex === 0 && (
                    <>
                      <button onClick={handleShuffle} className={styles.shuffleBtn}>
                        <FontAwesomeIcon icon={faShuffle} style={{ marginRight: '5px' }} />
                        {t(`Shuffle`)}
                      </button>
                      <button onClick={handleShuffle} className={styles.shuffleMobileBtn}>
                        <FontAwesomeIcon icon={faShuffle} />
                      </button>
                    </>
                  )}
                </div>
                {isTicketsLoading ?
                  <div className={styles.ticketList}>
                    {Array.from({ length: 8 }).map((_, index) => (
                      <SkeletonTicketCard key={index} />
                    ))}
                  </div>
                  :
                  <div className={`${styles.ticketList} ${styles.modalList}`}>
                    {visibleTickets.length > 0 ? (
                      visibleTickets?.map((ticket) => (
                        <div className={styles.lotteryBoxCard} key={ticket.id}>
                          <img src={ticket.lottery.lottery_brand_day.sample_url} alt="Sample" className={styles.ticketImg} />
                          <div className={`${styles.detailscard} ${styles[brand.lottery_brand_day.lottery_brand.code.toLowerCase() || 'default']}`}>
                            <div className={styles.ticketDetails}>
                              {ticket.lottery.lottery_brand_day.lottery_brand.code === 'MASAM' &&
                                <div className={styles.masamNumberRow}>
                                  <p className={styles.masamResultsLetter}>{ticket.masam.char}</p>
                                  {ticket.masam.recd.split("").map((char, index) => (
                                    <p key={index} className={styles.masamResultNumber}>{char}</p>
                                  ))}
                                </div>
                              }
                              {ticket.lottery.lottery_brand_day.lottery_brand.code === 'MEPO' &&
                                <div className={styles.masamNumberRow}>
                                  <p className={styles.masamResultsLetter}>{ticket.mepo.char}</p>
                                  <p className={styles.masamResultSpNumber}>{ticket.mepo.sno.padStart(2, '0')}</p>
                                  <p className={styles.masamResultNumber}>{ticket.mepo.n1.padStart(2, '0')}</p>
                                  <p className={styles.masamResultNumber}>{ticket.mepo.n2.padStart(2, '0')}</p>
                                  <p className={styles.masamResultNumber}>{ticket.mepo.n3.padStart(2, '0')}</p>
                                  <p className={styles.masamResultNumber}>{ticket.mepo.n4.padStart(2, '0')}</p>
                                </div>
                              }
                              {ticket.lottery.lottery_brand_day.lottery_brand.code === 'ADSA' &&
                                <div className={styles.adsaNumberRow}>
                                  <p className={styles.masamResultsLetter}>{ticket.adsa.char}</p>
                                  <p className={`${styles.adsaResultNumberA} ${styles.masamResultNumber}`}>{ticket.adsa.arange.padStart(2, '0')}</p>
                                  <p className={`${styles.adsaResultNumberB} ${styles.masamResultNumber}`}>{ticket.adsa.brange.padStart(3, '0')}</p>
                                  <p className={`${styles.adsaResultNumberC} ${styles.masamResultNumber}`}>{ticket.adsa.crange.padStart(4, '0')}</p>
                                </div>
                              }
                              {ticket.lottery.lottery_brand_day.lottery_brand.code === 'DHNI' &&
                                <>
                                  <div className={styles.adsaNumberRow}>
                                    <p className={styles.dhniResultsLetter}>{ticket.dhni.char1}</p>
                                    <p className={styles.dhniResultNumber}>{ticket.dhni.n1.padStart(2, '0')}</p>
                                    <p className={styles.dhniResultNumber}>{ticket.dhni.n2.padStart(2, '0')}</p>
                                    <p className={styles.dhniResultNumber}>{ticket.dhni.n3.padStart(2, '0')}</p>
                                    <p className={styles.dhniResultNumber}>{ticket.dhni.n4.padStart(2, '0')}</p>
                                  </div>
                                  <div className={styles.adsaNumberRow}>
                                    <p className={styles.dhniResultsLetter}>{ticket.dhni.char2}</p>
                                    <p className={styles.dhniResultNumberSp}>{ticket.dhni.special.padStart(5, '0')}</p>
                                  </div>
                                </>
                              }
                              {ticket.lottery.lottery_brand_day.lottery_brand.code === 'GOVI' &&
                                <div className={styles.masamNumberRow}>
                                  <p className={styles.masamResultsLetter}>{ticket.govi.char1}</p>
                                  <p className={styles.masamResultsLetter}>{ticket.govi.char2}</p>
                                  <p className={styles.masamResultNumber}>{ticket.govi.n1.padStart(2, '0')}</p>
                                  <p className={styles.masamResultNumber}>{ticket.govi.n2.padStart(2, '0')}</p>
                                  <p className={styles.masamResultNumber}>{ticket.govi.n3.padStart(2, '0')}</p>
                                  <p className={styles.masamResultNumber}>{ticket.govi.n4.padStart(2, '0')}</p>
                                </div>
                              }
                              {ticket.lottery.lottery_brand_day.lottery_brand.code === 'HADA' &&
                                <div className={styles.hadaCol}>
                                  <div className={styles.hadaLeftCol}>
                                    <img src={astroImages[ticket.hada.lagna]} alt={`Image ${ticket.hada.lagna}`} className={styles.hadaAstro} />
                                  </div>
                                  <div className={styles.hadaRighttCol}>
                                    <div className={styles.adsaNumberRow}>
                                      <p className={styles.dhniResultNumber}>{ticket.hada.n1.padStart(2, '0')}</p>
                                      <p className={styles.dhniResultNumber}>{ticket.hada.n2.padStart(2, '0')}</p>
                                      <p className={styles.dhniResultNumber}>{ticket.hada.n3.padStart(2, '0')}</p>
                                      <p className={styles.dhniResultNumber}>{ticket.hada.n4.padStart(2, '0')}</p>
                                    </div>
                                    <div className={styles.hadaNumberRow}>
                                      <p className={styles.hadaSpecial}>{ticket.hada.special}</p>
                                      <p className={styles.hadaDaywaLetter}>{ticket.hada.dayn}</p>
                                    </div>
                                  </div>
                                </div>
                              }
                              {ticket.lottery.lottery_brand_day.lottery_brand.code === 'JAYA' &&
                                <div className={styles.jayaNumberRow}>
                                  <p className={styles.masamResultsLetter}>{ticket.jaya.char}</p>
                                  {ticket.jaya.recd.split("").map((char, index) => (
                                    <p key={index} className={styles.masamResultNumber}>{char}</p>
                                  ))}
                                </div>
                              }
                              <p className={styles.pricetitle}>Next super Prize</p>
                              <p className={styles.prize}>Rs. {ticket.lottery.mega_prize.toLocaleString()}</p>
                              <p className={styles.brandName}>{ticket.lottery.lottery_brand_day.lottery_brand.name}</p>
                              <div className={styles.detailsRow}>
                                <p className={styles.rowText}>Draw: {ticket.lottery.draw_no}</p>
                                <p className={styles.rowText}>Date: {ticket.lottery.draw_date}</p>
                              </div>
                              <div className={styles.buttonsCol}>
                                {addedToCartIds.includes(ticket.id) ? (
                                  <button className={styles.buyBtn} type="button" disabled>Added</button>
                                ) : (
                                  <button className={styles.buyBtn} type="button" disabled={loadingTicketId === ticket.id} onClick={() => addToCart(ticket)}>{loadingTicketId === ticket.id ? <BeatLoader color='#079C34' /> : `Add to cart`}</button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      )))
                      : <SoldOut />}
                  </div>
                }
              </div>
            </div>
          </div>
        </>
      }
      {isTicketBulkModalOpen &&
        <>
          <div className={`main-container`}>
            <div className={styles.ticketModal}>
              <div className={styles.closeRow}>
                <FontAwesomeIcon icon={faXmark} className={styles.xClass} size="2xl" onClick={() => {
                  setTicketBulkModalOpen(false);
                  document.body.style.overflow = 'unset';
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }} />
              </div>
              <div className={`${styles.ticketModalContainer} ${styles.ticketBulkModalContainer}`}>
                <div className={styles.bulkListingHeader}>
                  <h2 className={styles.listingTitle}>{bulkTicketBrand?.lottery_brand_day.lottery_brand.name}</h2>
                </div>
                <div className={styles.ticketBrand}>
                  <div className={styles.bulkTicketBrandHeader}>
                    <div className={styles.ticketBrandHeaderLeft}>
                      <img src={bulkTicketBrand?.lottery_brand_day.lottery_brand.logo_url} alt="Sample" className={styles.brandImg} />
                    </div>
                    {/* <p className={styles.bulkBrandName}>{bulkTicketBrand?.lottery_brand_day.lottery_brand.name}</p> */}
                    <div className={styles.bulkTicketBrandHeaderRight}>
                      <FontAwesomeIcon icon={faMinus} cursor={'pointer'}
                        onClick={() => { if (bulkCount > 0) setBulkCount(bulkCount - 1) }} />
                      <p className={styles.bulkTicketCount}>
                        {bulkCount}
                      </p>
                      <FontAwesomeIcon icon={faPlus} cursor={'pointer'}
                        onClick={() => { if (bulkCount < 50) setBulkCount(bulkCount + 1) }} />
                    </div>
                  </div>
                </div>
                <div className={styles.footerBtn}>
                  <button className={`primary-btn ${styles.purchaseBtn}`} onClick={addBulkToCart}>
                    {creatingBulk ? <BeatLoader color='#ffffff' /> : `Add to Cart`}</button>
                </div>
              </div>
            </div>
          </div>
        </>
      }
      {isSubscribeModalOpen &&
        <>
          <div className={`main-container`}>
            <div className={styles.ticketModal}>
              <div className={styles.closeRow}>
                <FontAwesomeIcon icon={faXmark} className={styles.xClass} size="2xl" onClick={() => {
                  setSubscribeModalOpen(false);
                  document.body.style.overflow = 'unset';
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                  setSubCount(0);
                  setActiveFirstBtn(false);
                  setActiveSecondBtn(false);
                  setActiveThirdBtn(false);
                  setActiveFourthBtn(false);
                  setActiveDuFirstBtn(false);
                  setActiveDuSecondBtn(false);
                  setActiveDuThirdBtn(false);
                  setActiveDuFourthBtn(false);
                  setForever(false);
                }} />
              </div>
              <div className={`${styles.ticketModalContainer} ${styles.ticketSubModalContainer}`}>
                <div className={styles.bulkListingHeader}>
                  <img src={subscribeBrand?.lottery_brand_day.lottery_brand.logo_url} alt="Sample" className={styles.brandImg} />
                  <h2 className={styles.listingTitle} style={{ marginTop: '0px' }}>{subscribeBrand?.lottery_brand_day.lottery_brand.name}</h2>
                </div>
                <div className={styles.subCardBody}>
                  <div className={styles.subCardCount}>
                    <p className={styles.subCountTitle}>
                      Number of Tickets
                    </p>
                    <div className={styles.subCoundContainer}>
                      <FontAwesomeIcon icon={faMinus} cursor={'pointer'}
                        onClick={() => { if (subCount > 0) setSubCount(subCount - 1) }} />
                      <p className={styles.bulkTicketCount}>
                        {subCount}
                      </p>
                      <FontAwesomeIcon icon={faPlus} cursor={'pointer'}
                        onClick={() => { setSubCount(subCount + 1); setSubError({ ...subError, count: '' }) }} />
                    </div>
                  </div>
                  <p className={`text-danger`} style={{ color: "var(--russianViolet)", textAlign: 'center' }}>
                    * Number of Tickets per subscription payment.
                  </p>
                  <p className={styles.subTitle}>
                    Subscription Type
                  </p>
                  <div className={`${styles.fileInputWrapper} ${styles.buttonWrapper}`}>
                    <button type="button"
                      className={`${styles.timeBtn} ${activeFirstBtn ? styles.clicked : ''}`}
                      onClick={() => {
                        setSubData({ ...subData, recurrence: '1 Day' });
                        setActiveFirstBtn(true);
                        setActiveSecondBtn(false);
                        setActiveThirdBtn(false);
                        setActiveFourthBtn(false);
                        setSubError({ ...subError, recurrence: '' });
                      }}>Daily</button>
                    <button type="button"
                      className={`${styles.timeBtn} ${activeSecondtBtn ? styles.clicked : ''}`}
                      onClick={() => {
                        setSubData({ ...subData, recurrence: '1 Week' });
                        setActiveFirstBtn(false);
                        setActiveSecondBtn(true);
                        setActiveThirdBtn(false);
                        setActiveFourthBtn(false);
                        setSubError({ ...subError, recurrence: '' });
                      }}>Weekly</button>
                    <button type="button"
                      className={`${styles.timeBtn} ${activeThirdBtn ? styles.clicked : ''}`}
                      onClick={() => {
                        setSubData({ ...subData, recurrence: '2 Week' });
                        setActiveFirstBtn(false);
                        setActiveSecondBtn(false);
                        setActiveThirdBtn(true);
                        setActiveFourthBtn(false);
                        setSubError({ ...subError, recurrence: '' });
                      }}>Biweekly</button>
                    <button type="button"
                      className={`${styles.timeBtn} ${activeFourthBtn ? styles.clicked : ''}`}
                      onClick={() => {
                        setSubData({ ...subData, recurrence: '1 Month' });
                        setActiveFirstBtn(false);
                        setActiveSecondBtn(false);
                        setActiveThirdBtn(false);
                        setActiveFourthBtn(true);
                        setSubError({ ...subError, recurrence: '' });
                      }}>Monthly</button>
                  </div>
                  <p className={styles.subTitle}>
                    Duration
                  </p>
                  <div className={`${styles.fileInputWrapper} ${styles.buttonWrapper}`}>
                    <button type="button"
                      className={`${styles.timeBtn} ${activeDuFirstBtn ? styles.clicked : ''}`}
                      disabled={isForever}
                      onClick={() => {
                        setSubData({ ...subData, duration: '1 Month' });
                        setActiveDuFirstBtn(true);
                        setActiveDuSecondBtn(false);
                        setActiveDuThirdBtn(false);
                        setActiveDuFourthBtn(false);
                        setSubError({ ...subError, duration: '' });
                      }}>1 Month</button>
                    <button type="button"
                      className={`${styles.timeBtn} ${activeDuSecondtBtn ? styles.clicked : ''}`}
                      disabled={isForever}
                      onClick={() => {
                        setSubData({ ...subData, duration: '2 Month' });
                        setActiveDuFirstBtn(false);
                        setActiveDuSecondBtn(true);
                        setActiveDuThirdBtn(false);
                        setActiveDuFourthBtn(false);
                        setSubError({ ...subError, duration: '' });
                      }}>2 Month</button>
                    <button type="button"
                      className={`${styles.timeBtn} ${activeDuThirdBtn ? styles.clicked : ''}`}
                      disabled={isForever}
                      onClick={() => {
                        setSubData({ ...subData, duration: '6 Month' });
                        setActiveDuFirstBtn(false);
                        setActiveDuSecondBtn(false);
                        setActiveDuThirdBtn(true);
                        setActiveDuFourthBtn(false);
                        setSubError({ ...subError, duration: '' });
                      }}>6 Month</button>
                    <button type="button"
                      className={`${styles.timeBtn} ${activeDuFourthBtn ? styles.clicked : ''}`}
                      disabled={isForever}
                      onClick={() => {
                        setSubData({ ...subData, duration: '1 Year' });
                        setActiveDuFirstBtn(false);
                        setActiveDuSecondBtn(false);
                        setActiveDuThirdBtn(false);
                        setActiveDuFourthBtn(true);
                        setSubError({ ...subError, duration: '' });
                      }}>1 Year</button>
                  </div>
                  <div className={styles.subRow}>
                    <input
                      type="checkbox"
                      name="autoRenew"
                      checked={isForever}
                      onChange={() => {
                        setForever(!isForever);
                        setActiveDuFirstBtn(false);
                        setActiveDuSecondBtn(false);
                        setActiveDuThirdBtn(false);
                        setActiveDuFourthBtn(false);
                        setSubData({ ...subData, duration: '' });
                        setSubError({ ...subError, duration: '' })
                      }}
                    /> Auto Renew
                  </div>
                  <div className={styles.subDetails}>
                    <div className={styles.rowOne}>
                      <p>No of Tickets</p>
                      <p>{subCount}</p>
                    </div>
                    <div className={styles.rowTwo}>
                      <p>Duration</p>
                      <p>{isForever ? `Auto Renew` : subData.duration}</p>
                    </div>
                    <div className={styles.rowThree}>
                      <p>Amount</p>
                      <p>Rs. {subscribeBrand.price * subCount.toFixed(2)}</p>
                    </div>
                  </div>
                </div>
                <div className={styles.errorContainer}>
                  {subError.count && (
                    <p className={`text-danger`}>
                      {subError.count}
                    </p>
                  )}
                  {subError.duration && (
                    <p className={`text-danger`}>
                      {subError.duration}
                    </p>
                  )}
                  {subError.recurrence && (
                    <p className={`text-danger`}>
                      {subError.recurrence}
                    </p>
                  )}
                </div>
                <div className={styles.subFooterBtn}>
                  <button
                    onClick={checkoutOrder}
                    disabled={isLoading}
                    className={`primary-btn ${styles.purchaseBtn}`}>
                    {isLoading ? <BeatLoader color="#FFFFFF" /> : `Subscribe`}</button>
                  {/* <PayhereSubscriptionForm details={[subData, subCount, isForever, subscribeBrand]}
                    onValidate={() => validateSubscription()} /> */}
                </div>
              </div>
            </div>
          </div>
        </>
      }
    </>
  )
}

export default TicketListing;